export enum DeleteUsecase {
  ASSETGROUP,
  ASSET,
  ASSETGROUP_UNLINK
}
;
